import './cookieChange.types'
import { type CookieListItem } from './cookieChange.types'

export const getCurrentCookies = async (): Promise<CookieListItem[]> => {
  try {
    const cookieList = await (window as any).cookieStore.getAll()
    return cookieList.map((cookie: any) => ({
      name: cookie.name,
      domain: cookie?.domain,
      path: cookie?.path,
      expires: cookie?.expires,
      secure: cookie?.secure,
      sameSite: cookie?.sameSite,
    }))
  } catch (error) {
    console.warn('Failed to get cookies from CookieStore API:', error)
    return []
  }
}

export const createNewCookieObserver = (
  onNewCookie: (cookie: CookieListItem) => void
): (() => void) => {
  if (typeof window === 'undefined' || !('cookieStore' in window)) {
    console.warn('CookieStore API not available')
    return () => {}
  }

  const handleCookieChange = (event: any) => {
    // Only handle new cookies (changed array), ignore deletions
    event.changed.forEach((cookie: any) => {
      onNewCookie(cookie)
    })
  }

  const cookieStore = (window as any).cookieStore
  cookieStore.addEventListener('change', handleCookieChange)

  return () => {
    cookieStore.removeEventListener('change', handleCookieChange)
  }
}
